import { env } from '../../../common/util'

const financialSummaryPresetId = { dev: 'eiaibj6g6uuxmfbu', staging: 'eudwatduwtujes7r', prod: '2tspyef3f59unqyl' }
const followUpEmailPresetId = { dev: 'aur41tqdihe9u1kd', staging: 'dxq0qfghf7kekksd', prod: 'ekg2bcro6o85d6qw' }

export const FINANCIAL_SUMMARY_PRESET_ID = financialSummaryPresetId[env]
export const FOLLOW_UP_EMAIL_PRESET_ID = followUpEmailPresetId[env]
